export default function categoryNameToHumanReadableCategoryName(name) {
  if (name === 'HomeComfort') {
    return 'Home Comfort';
  }
  return name;
}